import { getTenantIdentifier } from '../contexts/TenantContext';

/**
 * Get tenant headers for API calls
 */
export function getTenantHeaders() {
  const tenantSlug = getTenantIdentifier();
  const headers = {
    'Content-Type': 'application/json',
  };

  if (tenantSlug) {
    headers['X-Tenant-Subdomain'] = tenantSlug;
  }

  return headers;
}

/**
 * Helper function to add tenant headers to fetch requests
 */
export function fetchWithTenant(url, options = {}) {
  const tenantHeaders = getTenantHeaders();
  const headers = {
    ...tenantHeaders,
    ...(options.headers || {}),
  };

  return fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  });
}
